import { BrowserView, MobileView } from 'react-device-detect'
import { Fade } from "react-awesome-reveal"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import '../../styles/Home/HomeHeader.css'
import homeHeader1 from '../../assets/images/home/home-header-1.jpg'
import homeHeader2 from '../../assets/images/home/home-header-2.jpg'
import homeHeader3 from '../../assets/images/home/home-header-3.jpg'
import homeHeader4 from '../../assets/images/home/home-header-4.jpg'
import homeHeader5 from '../../assets/images/home/home-header-5.jpg'
import homeHeader6 from '../../assets/images/home/home-header-6.jpg'
import homeHeader7 from '../../assets/images/home/home-header-7.jpg'
import homeHeader8 from '../../assets/images/home/home-header-8.jpg'
import Carousel from '../Utils/Carousel'

function HomeHeader() {

    const carouselData = [
        { src: homeHeader1, label: "Un toit, une famille, une vie" }, { src: homeHeader2, label: "Construction des maisons du cœur pour les familles démunies" },
        { src: homeHeader3, label: "Education, donner une chance pour l’avenir" }, { src: homeHeader4, label: "Education, soutenir les programmes scolaires" },
        { src: homeHeader5, label: "Humanitaire, cadeaux et jouets pour les enfants" }, { src: homeHeader6, label: "Humanitaire, aides alimentaires" },
        { src: homeHeader7, label: "Santé, soigner les plus pauvres" }, { src: homeHeader8, label: "Développement durable, cultures et élevages" }
    ]

    return (

        <>
            <BrowserView>
                <Fade direction={'down'} triggerOnce={true}>
                    <div className='header'>
                        <Carousel data={carouselData} />
                    </div>
                </Fade>
            </BrowserView>

            <MobileView>
                <Fade direction={'down'} triggerOnce={true}>
                    <div className='headerMobile'>
                        <Slider {...{
                            dots: false,
                            infinite: true,
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 8000,
                            speed: 500,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            pauseOnFocus: false,
                            pauseOnHover: false
                        }}>
                            <div>
                                <div className='headerSlideMobile'>
                                    <img src={homeHeader1} width={'100%'} alt="header1" />
                                </div>
                            </div>
                            <div>
                                <div className='headerSlideMobile'>
                                    <img src={homeHeader2} width={'100%'} alt="header2" />
                                </div>
                            </div>
                            <div>
                                <div className='headerSlideMobile'>
                                    <img src={homeHeader3} width={'100%'} alt="header3" />
                                </div>
                            </div>
                            <div>
                                <div className='headerSlideMobile'>
                                    <img src={homeHeader4} width={'100%'} alt="header4" />
                                </div>
                            </div>
                            <div>
                                <div className='headerSlideMobile'>
                                    <img src={homeHeader5} width={'100%'} alt="header5" />
                                </div>
                            </div>
                            <div>
                                <div className='headerSlideMobile'>
                                    <img src={homeHeader6} width={'100%'} alt="header6" />
                                </div>
                            </div>
                            <div>
                                <div className='headerSlideMobile'>
                                    <img src={homeHeader7} width={'100%'} alt="header7" />
                                </div>
                            </div>
                            <div>
                                <div className='headerSlideMobile'>
                                    <img src={homeHeader8} width={'100%'} alt="header8" />
                                </div>
                            </div>
                        </Slider>
                    </div>
                </Fade>
            </MobileView >
        </>

    )

}

export default HomeHeader
